import { Form } from 'antd';
import { UploadFile } from 'antd/lib/upload/interface';
import React, { useState } from 'react';
import i18n from '../../../i18n/config';
import { ALLOWED_FILE_TYPES } from '../../../shared';
import { HasButton, HasText, HasTextArea, HasTitle } from '../../atoms';
import { HasFileUpload } from '../../molecules';

interface ActionClosureDetailsProps {
  onSave: (note: string, files: UploadFile[]) => void;
  onCancel: () => void;
  loading?: boolean;
}

const NOTE_MAX_LENGTH = 1024;

const HasActionClosureDetails: React.FC<ActionClosureDetailsProps> = ({ onSave, onCancel, loading }) => {
  const [note, setNote] = useState<string>('');
  const [files, setFiles] = useState<UploadFile[]>([]);

  return (
    <div className="border p-3 mb-3">
      <HasTitle content={i18n.t('action.closure.title', 'Closure details')} level={4} style={{ fontSize: '14px' }} />
      <Form layout="vertical">
        <Form.Item
          label={<HasText content={i18n.t('action.closure.notesLabel', 'Completion notes')} strong />}
          colon={false}
          style={{ marginBottom: '12px' }}
        >
          <HasTextArea
            rows={4}
            maxLength={NOTE_MAX_LENGTH}
            placeholder={i18n.t('action.closure.notesPlaceholder', 'Describe how this action was completed...')}
            value={note}
            onChange={(event: any) => setNote(event.target.value)}
          />
        </Form.Item>
        <Form.Item
          label={<HasText content={i18n.t('action.closure.photoLabel', 'Evidence photo')} strong />}
          colon={false}
          style={{ marginBottom: '12px' }}
        >
          <HasFileUpload files={files} onChange={setFiles} accept={ALLOWED_FILE_TYPES.Image.join(',')} />
        </Form.Item>
      </Form>
      <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
        <HasButton type="default" onClick={onCancel} style={{ marginRight: '8px' }} disabled={loading}>
          {i18n.t('shared.cancel')}
        </HasButton>
        <HasButton type="primary" onClick={() => onSave(note, files)} loading={loading} disabled={loading}>
          {i18n.t('shared.save')}
        </HasButton>
      </div>
    </div>
  );
};

export { HasActionClosureDetails };
